import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../Assets/Images/Logowhitesvg.svg";
import Line from "../Assets/Images/Linered.svg";
import greenArrowDown from "../Assets/Images/greenArrowDown.svg";
import whiteArrowDown from "../Assets/Images/whiteArrowDown.svg";
import "../Assets/Styles/NavBar.css";
import OutlinePerson from "../Assets/Images/personoutlinewhite.svg";
import OutlinePersongreen from "../Assets/Images/Personoutlinegreen.svg";
import LogoRed from "../Assets/Images/LogoRed.svg";
import MobileMenuIcon from "../Assets/Images/Menu.png";
import redArrowRight from "../Assets/Images/MobileImages/redArrowRight.svg";
import manInRound from "../Assets/Images/MobileImages/Maninroundred.svg";
import Facebook from "../Assets/Images/MobileImages/Facebook(1).svg";
import LinkedIn from "../Assets/Images/MobileImages/Linkdin.svg";
import Instagram from "../Assets/Images/MobileImages/Instagram.png";
import ProductsModal from "./ProductsModal.js";
import AgentModal from "./AgentModal.js";
import { Menu, X } from "lucide-react";
import useScreenWidth from "../Hooks/useScreenWidth.js";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Hooks/langugaeContext.js";
import { useTranslation } from "../Hooks/useTranslation";

const NavBar = ({ onlyWhiteBg = false }) => {
  const translations = useTranslation();
  const { navbar: navbarLang } = translations;
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [language, setLanguage] = useState("Eng");
  const { language, toggleLanguage } = useContext(LanguageContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductsModalOpen, setIsProductsModalOpen] = useState(false);
  const [isAgentModalOpen, setIsAgentModalOpen] = useState(false);
  const screenSize = useScreenWidth();

  const isActive = (path) => location.pathname === path;

  // Modify isParentActive to handle multiple paths
  const isParentActive = (basePaths) => {
    return basePaths.some((path) => location.pathname.includes(path));
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const NavLinks = [
    {
      Label: navbarLang.home || "Home",
      Path: "/",
    },
    {
      Label: navbarLang.aboutus || "About Us",
      Path: "/about",
    },
    {
      Label: navbarLang.universalLife || "Universal Life Insurance",
      Path: "/universal-life-insurance",
    },
    {
      Label:
        navbarLang.indexedUniversalLife || "Indexed Universal Life Insurance",
      Path: "/indexed-universal-life-insurance",
    },
    {
      Label: navbarLang.termLife || "Term Life Insurance",
      Path: "/term-life-insurance",
    },
    {
      Label: navbarLang.criticalIllness || "Critical Illness Insurance",
      Path: "/critical-illness-insurance",
    },
    {
      Label: navbarLang.compareProducts || "Compare Products",
      Path: "/compare-plans",
    },
    {
      Label: navbarLang.faqs || "FAQs",
      Path: "/faqs",
    },
  ];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.pageYOffset > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isMobileMenuOpen]);
  const navBackgroundCondition =
    isHovered || isScrolled || isProductsModalOpen || isAgentModalOpen;

  const handleLanguageChange = (lang) => {
    // setLanguage(lang);
    toggleLanguage(lang);
    setIsDropdownOpen(false);
  };

  const handleProductsClick = (e) => {
    e.preventDefault();
    if (isAgentModalOpen) {
      setIsAgentModalOpen(false);
    }
    setIsProductsModalOpen(!isProductsModalOpen);
  };

  const handleAgentsClick = (e) => {
    e.preventDefault();
    if (isProductsModalOpen) {
      setIsProductsModalOpen(false);
    }
    setIsAgentModalOpen(!isAgentModalOpen);
  };

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  return (
    <>
      <div className="header-container ">
        {screenSize > 991 ? (
          <nav
            className={`fixed top-0 left-0 right-0  py-4 transition-colors duration-300 pt-7 z-50 animate__animated animate__fadeInDown ${
              navBackgroundCondition
                ? "bg-white shadow-md"
                : "bg-transparent hover:bg-white"
            }
            ${isScrolled ? "mt-[-50px]" : ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="container">
              <div className="flex justify-end">
                <div className="hidden md:flex items-center space-x-1 mr-[1rem] ml-auto mb-6">
                  {" "}
                  {/* Reduced space-x-4 to space-x-2 */}
                  <div className="cp flex items-center pr-2">
                    {isHovered ||
                    isScrolled ||
                    isProductsModalOpen ||
                    onlyWhiteBg ||
                    isAgentModalOpen ? (
                      <img
                        className="mr-1"
                        src={OutlinePersongreen}
                        width={16}
                        height={16}
                        alt="Green Arrow Down"
                      />
                    ) : (
                      <img
                        className="mr-1"
                        src={OutlinePerson}
                        width={16}
                        height={16}
                        alt="White Arrow Down"
                      />
                    )}
                    <a
                      href="#"
                      className={`transition-colors duration-300 upperlinktext text-[12px] font-semibold flex items-center pt-[1px] ${
                        isHovered ||
                        isScrolled ||
                        isProductsModalOpen ||
                        onlyWhiteBg ||
                        isAgentModalOpen
                          ? "text-[#0D4248]"
                          : "text-white"
                      }`}
                    >
                      Login
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex justify-between">
                <button
                  className="md:hidden ml-auto"
                  onClick={toggleMobileMenu}
                >
                  {isMobileMenuOpen ? (
                    <X
                      className={`w-6 h-6 ${
                        isHovered || isScrolled ? "text-black" : "text-white"
                      }`}
                    />
                  ) : (
                    <Menu
                      className={`w-6 h-6 ${
                        isHovered || isScrolled ? "text-black" : "text-white"
                      }`}
                    />
                  )}
                </button>

                <div
                  className={`md:hidden fixed top-0 right-0 h-full w-64 bg-white transform transition-transform duration-300 ease-in-out ${
                    isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
                  } shadow-lg z-50 pt-20`}
                >
                  <div className="flex flex-col space-y-4 px-6">
                    <a href="/about" className="text-black linktext ">
                      {navbarLang.aboutus || "About Us"}
                    </a>
                    <a href="#" className="text-black linktext">
                      Products
                    </a>
                    <a href="#" className="text-black linktext">
                      Agents
                    </a>
                    <div className="pt-4 border-t">
                      <a href="#" className="text-black linktext">
                        Client Portal
                      </a>
                    </div>
                    <Link
                      to={
                        location.pathname === "/"
                          ? "/?section=footer"
                          : `${location.pathname}?section=footer`
                      }
                    >
                      <button className="px-6 py-2 rounded-full bg-red-600 text-white hover:bg-black linktext mt-4">
                        Contact Us
                      </button>
                    </Link>
                    <div className="mt-4">
                      {/* Language selector for mobile */}
                      <div
                        className="border rounded-full px-3 py-1 cursor-pointer text-black"
                        onClick={toggleDropdown}
                      >
                        <span>{language}</span>
                        <img
                          src={greenArrowDown}
                          alt="Red Arrow Down"
                          className="inline ml-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Logo */}
                <div className="flex items-end space-x-2 max-w-[1440px]">
                  <Link to="/">
                    {isHovered ||
                    isScrolled ||
                    isProductsModalOpen ||
                    onlyWhiteBg ||
                    isAgentModalOpen ? (
                      <img
                        src={LogoRed}
                        alt="Company Logo"
                        className={`h-10 Logoimg ${
                          isHovered || isScrolled ? "" : ""
                        }`}
                      />
                    ) : (
                      <img
                        src={Logo}
                        alt="Company Logo"
                        className={`h-10 Logoimg ${
                          isHovered || isScrolled
                            ? "brightness-0 filter contrast-0"
                            : ""
                        }`}
                      />
                    )}
                  </Link>
                </div>

                {/* Navigation Links */}

                {/* Right Navigation Items */}

                {
                  <div className="flex flex-col items-center space-y-6">
                    {/* Existing Navigation Links */}
                    <div className="flex items-center">
                      <div className="hidden md:flex items-center space-x-16 mr-12 whitespace-nowrap ">
                        <Link
                          to="/"
                          className={`${
                            isActive("/") ? "nav-active" : ""
                          } transition-colors duration-300 linktext hover:text-[#0D4248] ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "text-black"
                              : "text-white"
                          }`}
                        >
                          {navbarLang.home || "Home"}
                        </Link>
                        <Link
                          to={"/about"}
                          className={`${
                            isActive("/about") ? "nav-active" : ""
                          } transition-colors duration-300 linktext hover:text-[#0D4248] ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "text-black"
                              : "text-white"
                          }`}
                        >
                          {navbarLang.aboutus || "About Us"}
                        </Link>
                        <a
                          // href="#"
                          className={`${
                            isParentActive([
                              "/indexed-universal-life-insurance",
                              "/term-life-insurance",
                              "/universal-life-insurance",
                              "/critical-illness-insurance",
                              "/compare-plans",
                            ])
                              ? "nav-active"
                              : ""
                          }  transition-colors duration-300 linktext cursor-pointer hover:text-[#0D4248] ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "text-black"
                              : "text-white"
                          }`}
                          onClick={handleProductsClick}
                        >
                          {navbarLang.product || "Products"}
                        </a>
                        <Link
                          to={"/"}
                          className={`transition-colors duration-300 linktext hover:text-[#0D4248] ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "text-black"
                              : "text-white"
                          }`}
                          onClick={handleAgentsClick}
                        >
                          {navbarLang.agents || "Agents"}
                        </Link>
                      </div>

                      <Link
                        to={
                          location.pathname === "/"
                            ? "/?section=footer"
                            : `${location.pathname}?section=footer`
                        }
                      >
                        <button
                          className={`px-6 py-2 ml-1 font-bold rounded-full transition-colors duration-300 linktext whitespace-nowrap contactusbtn  ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "bg-[#0D4248] text-[#ffffff] hover:bg-[#0D4248] hover:text-[#fff] "
                              : "bg-[#ffffff] text-[#00363C] hover:bg-[#0D4248] hover:text-[#fff] "
                          }`}
                        >
                          {navbarLang.contactUs || "Contact Us"}
                        </button>
                      </Link>

                      <div className="dropdownlanguage">
                        <button
                          className={`button flex font-semibold ml-2 text-[14px] items-center ${
                            isHovered ||
                            isScrolled ||
                            isProductsModalOpen ||
                            onlyWhiteBg ||
                            isAgentModalOpen
                              ? "border-[#0D4248] text-[#0D4248]"
                              : "border-white text-white"
                          }`}
                          onClick={toggleDropdown}
                        >
                          {language}
                          {isHovered ||
                          isScrolled ||
                          isProductsModalOpen ||
                          onlyWhiteBg ||
                          isAgentModalOpen ? (
                            <img
                              className="arrodownicon -ml-1"
                              src={greenArrowDown}
                              alt="Red Arrow Down"
                            />
                          ) : (
                            <img
                              className="arrodownicon -ml-1"
                              src={whiteArrowDown}
                              alt="White Arrow Down"
                            />
                          )}
                        </button>
                        {isDropdownOpen && (
                          <div className="absolute mt-2 w-32 bg-white border border-gray-200 rounded-lg shadow-lg">
                            <ul className="">
                              <li
                                onClick={() => handleLanguageChange("Eng")}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                              >
                                Eng
                              </li>
                              <li
                                onClick={() => handleLanguageChange("Es")}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                              >
                                Es
                              </li>
                              {/* <li
                                onClick={() => handleLanguageChange("Pu")}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                              >
                                Pu
                              </li> */}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </nav>
        ) : (
          <>
            <div className="mobile-maindivNavBar pt-6 px-[8%] absolute w-full z-50 flex justify-between items-center bg-transparent">
              <Link to="/">
                <img
                  src={onlyWhiteBg ? LogoRed : Logo}
                  alt="Company Logo"
                  className="h-8"
                />
              </Link>
              <div
                onClick={toggleMobileMenu}
                className="menu-icon cursor-pointer fixed right-0 mr-2"
              >
                <div className="w-[64px] h-[64px] bg-[#bebdbd2e] rounded-full">
                  <img className="p-2" src={MobileMenuIcon} alt="MenuIcon" />
                </div>
              </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40"
                onClick={toggleMobileMenu}
              />
            )}

            {/* Mobile Menu Sidebar */}
            <div
              className={` mobilemenudiv fixed top-0 left-0 h-[100vh] pb-6 overflow-x-scroll w-[89%] bg-white transform transition-transform duration-300 ease-in-out z-50  ${
                isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
              }`}
            >
              <div className="flex justify-between py-11 px-5">
                <img src={LogoRed} alt="Company Logo" className={``} />
                {/* Mobile language */}
                <div className="dropdownlanguage">
                  <ul className="flex">
                    <li
                      onClick={() => handleLanguageChange("Eng")}
                      className={`px-4  text-xs cursor-pointer uppercase border-r border-black/10
                        ${
                          language === "Eng"
                            ? "text-[#ED1C2C] underline "
                            : "text-black/60"
                        }`}
                    >
                      Eng
                    </li>

                    <li
                      onClick={() => handleLanguageChange("Es")}
                      className={`px-4 text-xs cursor-pointer  uppercase
                        ${
                          language === "Es"
                            ? "text-[#ED1C2C] underline  "
                            : "text-black/60 "
                        }`}
                    >
                      Esp
                    </li>
                  </ul>
                </div>
              </div>
              <hr className=" border-gray-200 h-[1px] bg-[#DADADA]" />
              {NavLinks?.map((item, idx) => {
                return (
                  <>
                    <div className="navlinksdiv flex flex-col">
                      <Link
                        to={item.Path}
                        className="text-black mobile-linkTexts hover:text-red-600 cursor-pointer "
                      >
                        <div className="linkdiv my-7 ml-8  flex justify-between cursor-pointer  ">
                          {item.Label}

                          <img
                            className="redArrowRightnav mr-9 "
                            src={redArrowRight}
                            alt=""
                          />
                        </div>
                      </Link>
                      <hr className=" border-gray-200 h-[1px] bg-[#DADADA] " />
                    </div>
                  </>
                );
              })}
              <div className="navlinksdiv flex flex-col">
                <div className="linkdiv my-7 ml-8  flex items-center cursor-pointer  ">
                  <img src={manInRound} alt="" srcset="" />
                  <a
                    href="https://secured.afibl.com/"
                    target="_blank"
                    className="text-black mobile-linkTexts ml-3 hover:text-blue-700 "
                  >
                    {navbarLang.agents || "Agents"}
                  </a>
                </div>
                <hr className=" border-gray-200 h-[1px] bg-[#DADADA] " />
              </div>

              <div className="navlinksdiv flex flex-col">
                <hr className=" border-gray-200 h-[1px] bg-[#DADADA] " />
              </div>

              <div className="socialmediadiv flex ml-[25px] mt-[15px] ">
                <img className="mr-2" src={Facebook} alt="" />
                <img className="mx-2" src={Instagram} alt="" />
                <img className="mx-2" src={LinkedIn} alt="" />
              </div>
              <div className="navfootertextdiv ml-9 mt-4 pb-14 ">
                <p className="Politicatext mb-2 ">Politica de privacidad</p>
                <p className="Copyrighttext">
                  {" "}
                  Copyright © American Fidelity Global Solutions | Política de
                  privacidad | Design by Wemark.{" "}
                </p>
              </div>
            </div>
          </>
        )}
        <ProductsModal
          isOpen={isProductsModalOpen}
          isScrolled={isScrolled}
          onClose={() => setIsProductsModalOpen(false)}
        />
        <AgentModal
          isOpen={isAgentModalOpen}
          isScrolled={isScrolled}
          onClose={() => setIsAgentModalOpen(false)}
        />
      </div>
    </>
  );
};

export default NavBar;
